import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// SVG icons
// import VueSVGIcon from 'vue-svgicon'
import SvgIcon from 'vue-svgicon'

// Masonry CSS layout
import VueMasonry from 'vue-masonry-css'

Vue.config.productionTip = false

Vue.use(SvgIcon)
Vue.use(VueMasonry);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
